export const NAV_ITEMS = [
  { name: 'My Connected Home', icon: 'home', id: 1 },
  { name: '|', icon: '', disabled: true },
  { name: 'connectivity', icon: '' },
  { name: 'security', icon: '' },
  { name: 'energy', icon: '' },
];
